import Head from 'next/head';

const ScrollRestorationDisabler = () => {
  return (
    <Head>
      {/* Tell the browser to never restore the scroll position on load */}
      <script
        dangerouslySetInnerHTML={{
          __html: `history.scrollRestoration = "manual"`,
        }}
      />
    </Head>
  );
};

export default ScrollRestorationDisabler;
